import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RequestManagerService {
  // ユーザーIDごとのリクエスト管理
  private userRequests: Map<string, Map<string, Subject<void>>> = new Map();
  
  // 現在のユーザーID（実際の実装では認証サービスから取得）
  private currentUserId: string = 'default';

  constructor() {}

  /**
   * ユーザーIDを設定
   */
  setCurrentUserId(userId: string): void {
    this.currentUserId = userId;
  }

  /**
   * リクエストタイプごとのキャンセルSubjectを取得
   */
  getCancelSubject(requestType: string): Subject<void> {
    if (!this.userRequests.has(this.currentUserId)) {
      this.userRequests.set(this.currentUserId, new Map());
    }
    
    const userRequestMap = this.userRequests.get(this.currentUserId)!;
    
    if (!userRequestMap.has(requestType)) {
      userRequestMap.set(requestType, new Subject<void>());
    }
    
    return userRequestMap.get(requestType)!;
  }

  /**
   * 特定のリクエストタイプの進行中のリクエストをキャンセル
   */
  cancelRequest(requestType: string): void {
    const cancelSubject = this.getCancelSubject(requestType);
    cancelSubject.next();
  }

  /**
   * ユーザーの全リクエストをキャンセル
   */
  cancelAllUserRequests(): void {
    const userRequestMap = this.userRequests.get(this.currentUserId);
    if (userRequestMap) {
      userRequestMap.forEach(cancelSubject => {
        cancelSubject.next();
      });
    }
  }

  /**
   * 特定のリクエストタイプのObservableをキャンセル可能にする
   */
  makeCancellable<T>(observable: Observable<T>, requestType: string): Observable<T> {
    return observable.pipe(
      takeUntil(this.getCancelSubject(requestType))
    );
  }

  /**
   * ユーザーがログアウトした際のクリーンアップ
   */
  cleanupUser(userId: string): void {
    const userRequestMap = this.userRequests.get(userId);
    if (userRequestMap) {
      userRequestMap.forEach(cancelSubject => {
        cancelSubject.next();
        cancelSubject.complete();
      });
      this.userRequests.delete(userId);
    }
  }

  /**
   * 全ユーザーのリクエストをクリーンアップ
   */
  cleanupAllUsers(): void {
    this.userRequests.forEach((userRequestMap, userId) => {
      this.cleanupUser(userId);
    });
  }
}

